import React from 'react';

const DeliveryOptions = ({ selectedOption, onSelectOption, sedes, selectedSede, onSelectSede }) => {
  return (
    <div className="delivery-options-section">
      <h3>Opciones de Entrega</h3>
      <div className="delivery-options-buttons">
        <button 
          className={`delivery-option-btn ${selectedOption === 'domicilio' ? 'active' : ''}`}
          onClick={() => onSelectOption('domicilio')}
        >
          Domicilio
        </button>
        <button 
          className={`delivery-option-btn ${selectedOption === 'recoger' ? 'active' : ''}`}
          onClick={() => onSelectOption('recoger')}
        >
          Recoger en Restaurante
        </button>
      </div>

      {selectedOption === 'recoger' && (
        <div className="sede-selection-container">
          <label htmlFor="sede-select">Selecciona una Sede:</label>
          <select 
            id="sede-select" 
            value={selectedSede ? selectedSede.id : ''}
            onChange={(e) => onSelectSede(sedes.find(sede => sede.id === e.target.value))}
          >
            <option value="">-- Selecciona una Sede --</option>
            {sedes.map(sede => (
              <option key={sede.id} value={sede.id}>{sede.name}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default DeliveryOptions;
